// import React, { useEffect, useState } from "react";
// import useApi from "../CustomHooks/useApi";

// const AepsMerchantdetails = () => {
//   const [userData, setUserData] = useState(null);
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showTransactionDetails, setShowTransactionDetails] = useState(false);

//   const { callApi: aepsmerchantdetails } = useApi(
//     `/itpay/aeps/backend/merchant-details`,
//     "GET"
//   );

//   const fetchData = async (mobile) => {
//     if (!mobile.trim()) {
//       alert("Please enter a mobile number");
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await aepsmerchantdetails(null, `?mobilenumber=${mobile}`);
//       console.log("API Response:", response);
//       if (response?.userId) {
//         setUserData(response);
//       } else {
//         setUserData(null);
//         alert("No data found for this mobile number");
//       }
//     } catch (error) {
//       console.error("Failed to fetch user data:", error);
//       setUserData(null);
//       alert("Error fetching data. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = () => {
//     fetchData(mobileNumber);
//   };

//   const renderHierarchy = (hierarchy) => {
//     if (!hierarchy) return null;

//     // Build hierarchy array from bottom to top
//     const buildHierarchyArray = (node) => {
//       const nodes = [];
//       let current = node;
//       while (current) {
//         nodes.unshift(current);
//         current = current.parent;
//       }
//       return nodes;
//     };

//     const hierarchyArray = buildHierarchyArray(hierarchy);

//     return (
//       <div className="grid grid-cols-1 gap-4">
//         {hierarchyArray.map((node, index) => (
//           <div key={node.userId} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//             <div className="p-3 bg-gray-50 rounded">
//               <p className="text-sm text-gray-600">Level {index + 1} - {node.role.replace(/_/g, ' ')}</p>
//               <p className="font-medium">{node.name}</p>
//             </div>
//             <div className="p-3 bg-gray-50 rounded">
//               <p className="text-sm text-gray-600">Mobile Number</p>
//               <p className="font-medium">{node.mobileNo}</p>
//             </div>
//             <div className="p-3 bg-gray-50 rounded">
//               <p className="text-sm text-gray-600">User ID</p>
//               <p className="font-medium">{node.userId}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className="p-6 max-w-7xl mx-auto">
//       <h1 className="text-3xl font-bold text-gray-800 mb-6">Merchant Details</h1>

//       {/* Search Section */}
//       <div className="bg-white shadow-md rounded-lg p-6 mb-6 border border-gray-200">
//         <h2 className="text-xl font-semibold mb-4 text-gray-700">Search by Mobile Number</h2>
//         <div className="flex gap-4 items-center">
//           <input
//             type="text"
//             value={mobileNumber}
//             onChange={(e) => setMobileNumber(e.target.value)}
//             placeholder="Enter Mobile Number"
//             className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//           />
//           <button
//             onClick={handleSearch}
//             disabled={loading}
//             className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             {loading ? "Searching..." : "Search"}
//           </button>
//         </div>
//       </div>

//       {/* Loading State */}
//       {loading && (
//         <div className="p-6">
//           <div className="animate-pulse space-y-4">
//             <div className="h-6 bg-gray-300 rounded w-1/3" />
//             <div className="h-4 bg-gray-200 rounded w-1/2" />
//             <div className="h-4 bg-gray-200 rounded w-1/4" />
//           </div>
//         </div>
//       )}

//       {/* Merchant Data Display */}
//       {userData && !loading && (
//         <div className="space-y-6">
//           {/* AEPS KYC Status */}
//           <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
//             <h2 className="text-xl font-semibold mb-4 text-gray-700">AEPS KYC Status</h2>
//             <div className="flex items-center gap-3">
//               <div className={`flex items-center gap-2 px-4 py-2 rounded-full ${
//                 userData.aepsKyc ? 'bg-green-100 text-green-800 border border-green-300' : 'bg-red-100 text-red-800 border border-red-300'
//               }`}>
//                 {userData.aepsKyc ? (
//                   <>
//                     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                       <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                     </svg>
//                     <span className="font-medium">KYC Verified</span>
//                   </>
//                 ) : (
//                   <>
//                     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                       <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//                     </svg>
//                     <span className="font-medium">KYC Pending</span>
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Merchant Details from userHighLevelRolesResponse */}
//           {userData.userHighLevelRolesResponse && (
//             <>
//               {/* Basic Merchant Information */}
//               <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
//                 <h2 className="text-xl font-semibold mb-4 text-gray-700">Merchant Information</h2>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                   <div className="p-3 bg-blue-50 rounded">
//                     <p className="text-sm text-gray-600">User ID</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.userId}</p>
//                   </div>
//                   <div className="p-3 bg-blue-50 rounded">
//                     <p className="text-sm text-gray-600">Mobile Number</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.mobile_number}</p>
//                   </div>
//                   <div className="p-3 bg-blue-50 rounded">
//                     <p className="text-sm text-gray-600">Role Type</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.role_type}</p>
//                   </div>
//                   <div className="p-3 bg-blue-50 rounded">
//                     <p className="text-sm text-gray-600">Onboarding Status</p>
//                     <p className="font-medium text-green-600">{userData.merchantOnboardingStatus}</p>
//                   </div>
//                   <div className="p-3 bg-blue-50 rounded">
//                     <p className="text-sm text-gray-600">Created At</p>
//                     <p className="font-medium">{userData.createdAt ? new Date(userData.createdAt).toLocaleString() : 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-blue-50 rounded">
//                     <p className="text-sm text-gray-600">Updated At</p>
//                     <p className="font-medium">{userData.updatedAt ? new Date(userData.updatedAt).toLocaleString() : 'N/A'}</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Personal Details */}
//               <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
//                 <h2 className="text-xl font-semibold mb-4 text-gray-700">Personal Details</h2>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                   <div className="p-3 bg-green-50 rounded">
//                     <p className="text-sm text-gray-600">Full Name</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.fullName || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-green-50 rounded">
//                     <p className="text-sm text-gray-600">Father's Name</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.fatherName || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-green-50 rounded">
//                     <p className="text-sm text-gray-600">Date of Birth</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.dob || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-green-50 rounded">
//                     <p className="text-sm text-gray-600">Gender</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.gender || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-green-50 rounded">
//                     <p className="text-sm text-gray-600">Aadhar Number</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.aadharNumber || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-green-50 rounded">
//                     <p className="text-sm text-gray-600">Aadhar Address</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.aadharAddress || 'N/A'}</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Shop Details */}
//               <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
//                 <h2 className="text-xl font-semibold mb-4 text-gray-700">Shop Details</h2>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div className="p-3 bg-yellow-50 rounded">
//                     <p className="text-sm text-gray-600">Shop Name</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopName || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-yellow-50 rounded">
//                     <p className="text-sm text-gray-600">Shop Address</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopAddress || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-yellow-50 rounded">
//                     <p className="text-sm text-gray-600">Shop State</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopState || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-yellow-50 rounded">
//                     <p className="text-sm text-gray-600">Shop District</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopDistrict || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-yellow-50 rounded">
//                     <p className="text-sm text-gray-600">Shop Pin Code</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopPinCode || 'N/A'}</p>
//                   </div>
//                   <div className="p-3 bg-yellow-50 rounded">
//                     <p className="text-sm text-gray-600">Shop Landmark</p>
//                     <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopLandmark || 'N/A'}</p>
//                   </div>
//                 </div>
//               </div>

//               {/* User Hierarchy */}
//               {userData.userHighLevelRolesResponse.userHierarchyResponse && (
//                 <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
//                   <h2 className="text-xl font-semibold mb-4 text-gray-700">User Hierarchy</h2>
//                   <div className="space-y-6">
//                     {renderHierarchy(userData.userHighLevelRolesResponse.userHierarchyResponse)}
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {/* AEPS Transaction Details - Moved to Last */}
//           {userData.aepsTxnDetails && userData.aepsTxnDetails.length > 0 && (
//             <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
//               <div className="flex items-center justify-between mb-4">
//                 <h2 className="text-xl font-semibold text-gray-700">AEPS Transaction Details</h2>
//                 <button
//                   onClick={() => setShowTransactionDetails(!showTransactionDetails)}
//                   className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors"
//                 >
//                   <span>View</span>
//                   <svg 
//                     className={`w-4 h-4 transition-transform ${showTransactionDetails ? 'rotate-180' : ''}`} 
//                     fill="none" 
//                     stroke="currentColor" 
//                     viewBox="0 0 24 24"
//                   >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                   </svg>
//                 </button>
//               </div>

//               {showTransactionDetails && (
//                 <div className="space-y-4">
//                   {userData.aepsTxnDetails.map((txn, index) => (
//                     <div key={index} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
//                       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">Transaction ID</p>
//                           <p className="font-medium">{txn.txnId}</p>
//                         </div>
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">Mobile Number</p>
//                           <p className="font-medium">{txn.mobileNumber}</p>
//                         </div>
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">Amount</p>
//                           <p className="font-medium text-green-600">₹{txn.amount?.toLocaleString()}</p>
//                         </div>
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">Status</p>
//                           <p className={`font-medium ${txn.status === 'SUCCESS' ? 'text-green-600' : 'text-red-600'}`}>
//                             {txn.status}
//                           </p>
//                         </div>
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">Aadhaar Number</p>
//                           <p className="font-medium">{txn.aadhaarNumber}</p>
//                         </div>
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">External Txn ID</p>
//                           <p className="font-medium">{txn.externalTxnId || 'N/A'}</p>
//                         </div>
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">Bank RRN</p>
//                           <p className="font-medium">{txn.bankRRN || 'N/A'}</p>
//                         </div>
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">Description</p>
//                           <p className="font-medium">{txn.description || 'N/A'}</p>
//                         </div>
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">Created At</p>
//                           <p className="font-medium">{new Date(txn.created_at).toLocaleString()}</p>
//                         </div>
//                         <div className="p-3 bg-white rounded">
//                           <p className="text-sm text-gray-600">Updated At</p>
//                           <p className="font-medium">{new Date(txn.updated_at).toLocaleString()}</p>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       {/* No Data Message */}
//       {!userData && !loading && (
//         <div className="text-center py-8">
//           <p className="text-gray-500">No merchant details found. Please search with a valid mobile number.</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AepsMerchantdetails;

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../CustomHooks/useApi";
import axios from "axios";

const AepsMerchantdetails = () => {
  const [userData, setUserData] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [showTransactionDetails, setShowTransactionDetails] = useState(false);
  
  // New states for AEPS toggle functionality
  const [loadingStates, setLoadingStates] = useState({
    AEPS_TOGGLE: false
  });
  const [notification, setNotification] = useState(null);
  const [services, setServices] = useState([
    { 
      name: 'AEPS', 
      serviceKey: 'aeps', 
      isActive: false 
    }
  ]);
  const [serviceLoading, setServiceLoading] = useState(true);
  const [serviceError, setServiceError] = useState(null);

  // Redux selectors
  const userId = useSelector((state) => state.auth.employeeDetails.userId);
  const token = useSelector((state) => state.auth.employeeDetails?.token);
  const username = useSelector((state) => state.auth.employeeDetails?.username);
  
  const Hurl = process.env.REACT_APP_Helpdesk_URL;

  const { callApi: aepsmerchantdetails } = useApi(
    `/itpay/aeps/backend/merchant-details`,
    "GET"
  );

  // Fetch service permissions on component mount
  useEffect(() => {
    const fetchServicePermissions = async () => {
      if (!userId || !token) {
        setServiceLoading(false);
        return;
      }
      
      try {
        const res = await axios.get(`${Hurl}/api/service-status?user_id=${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        // Extract serviceStatus from the response
        const serviceStatus = res.data.serviceStatus;
        
        // Create a mapping object for easier access
        const serviceMapping = {
          'aeps': serviceStatus.isAepsEnabled,
          'dmt': serviceStatus.isDmtEnabled,
          'ppi': serviceStatus.isPPIEnabled,
          'ccbp': serviceStatus.isCcbpEnabled,
          'pgin': serviceStatus.isPgInEnabled,
          'payout': serviceStatus.isPayoutEnabled,
          'recharge': serviceStatus.isRechargeEnabled
        };
        
        // Update services with API response
        setServices(prevServices =>
          prevServices.map(service => ({
            ...service,
            isActive: serviceMapping[service.serviceKey] || false
          }))
        );
        
        // Update merchant data with current AEPS status from service API
        if (userData?.userHighLevelRolesResponse && serviceStatus.isAepsEnabled !== undefined) {
          setUserData(prevData => ({
            ...prevData,
            isAepsEnabled: serviceStatus.isAepsEnabled
          }));
        }
        
        setServiceError(null);
      } catch (error) {
        console.error('Error fetching service permissions:', error);
        setServiceError('Failed to load service permissions');
        
        // Set all services to inactive on error
        setServices(prevServices =>
          prevServices.map(service => ({
            ...service,
            isActive: false
          }))
        );
      } finally {
        setServiceLoading(false);
      }
    };
    
    fetchServicePermissions();
  }, [userId, token, Hurl, userData?.userHighLevelRolesResponse]);

  // Show notification function
  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 5000);
  };

  // Mobile number validation function
  const validateMobileNumber = (mobile) => {
    // Remove any non-digit characters
    const cleanMobile = mobile.replace(/\D/g, '');
    
    // Check if length is between 6-10 digits
    if (cleanMobile.length < 6 || cleanMobile.length > 10) {
      return { isValid: false, message: "Mobile number must be between 6-10 digits" };
    }
    
    // Check if first digit is between 6-9
    const firstDigit = parseInt(cleanMobile.charAt(0));
    if (firstDigit < 6 || firstDigit > 9) {
      return { isValid: false, message: "Mobile number must start with digits 6-9" };
    }
    
    return { isValid: true, message: "" };
  };

  // Helper function to set loading state for specific button
  const setButtonLoading = (mode, isLoading) => {
    setLoadingStates(prev => ({
      ...prev,
      [mode]: isLoading
    }));
  };

  // Handle mobile number input change
  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    // Only allow digits and limit to 10 characters
    const cleanValue = value.replace(/\D/g, '').slice(0, 10);
    setMobileNumber(cleanValue);
  };

  const fetchData = async (mobile) => {
    if (!mobile.trim()) {
      showNotification("Please enter a mobile number", 'error');
      return;
    }

    // Validate mobile number before API call
    const mobileValidation = validateMobileNumber(mobile);
    if (!mobileValidation.isValid) {
      showNotification(mobileValidation.message, 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await aepsmerchantdetails(null, `?mobilenumber=${mobile}`);
      console.log("API Response:", response);
      if (response?.userId) {
        // Fetch current service status and update merchant data
        try {
          const serviceRes = await axios.get(`${Hurl}/api/service-status?user_id=${userId}`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          
          const serviceStatus = serviceRes.data.serviceStatus;
          
          // Update merchant data with current AEPS status from service API
          const updatedUserData = {
            ...response,
            isAepsEnabled: serviceStatus.isAepsEnabled
          };
          
          setUserData(updatedUserData);
        } catch (serviceError) {
          console.error("Failed to fetch service status:", serviceError);
          // Use original merchant data if service status fetch fails
          setUserData(response);
        }
        
        showNotification("Merchant data found successfully!", 'success');
      } else {
        setUserData(null);
        showNotification("No data found for this mobile number", 'error');
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
      setUserData(null);
      showNotification("Error fetching data. Please try again.", 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchData(mobileNumber);
  };

  // AEPS Toggle Handler
  const handleAepsToggle = async (currentStatus) => {
    if (!mobileNumber.trim()) {
      showNotification("Please search for a merchant first", 'error');
      return;
    }

    const mobileValidation = validateMobileNumber(mobileNumber);
    if (!mobileValidation.isValid) {
      showNotification(mobileValidation.message, 'error');
      return;
    }

    // Check if user has permission to toggle AEPS
    const aepsService = services.find(service => service.serviceKey === 'aeps');
    if (!aepsService || !aepsService.isActive) {
      showNotification("❌ You don't have permission to toggle AEPS service", 'error');
      return;
    }

    setButtonLoading('AEPS_TOGGLE', true);

    try {
      const body = {
        "mobile_number": mobileNumber,
        "serviceKey": "isAepsEnabled",
        "newValue": !currentStatus,
        "updatedBy": username
      };

      console.log("AEPS Toggle Request Body:", body);

      const response = await axios.put(`${Hurl}/api/toggle-service`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log("AEPS Toggle Response:", response.data);

      if (response.status === 200 || response.data) {
        const newStatus = !currentStatus ? 'Enabled' : 'Disabled';
        showNotification(`✅ AEPS Successfully ${newStatus}!`, 'success');
        setUserData(prevData => ({
          ...prevData,
          isAepsEnabled: !currentStatus
        }));
      } else {
        showNotification("❌ Failed to toggle AEPS status", 'error');
      }
    } catch (error) {
      console.error("Failed to toggle AEPS:", error);
      showNotification(`❌ Error: ${error.response?.data?.message || error.message || 'Failed to toggle AEPS. Please try again.'}`, 'error');
    } finally {
      setButtonLoading('AEPS_TOGGLE', false);
    }
  };

  // Get mobile validation status
  const getMobileValidationStatus = () => {
    if (!mobileNumber) return { isValid: true, message: "" };
    return validateMobileNumber(mobileNumber);
  };

  const mobileValidationStatus = getMobileValidationStatus();

  // Get AEPS service permission status
  const aepsService = services.find(service => service.serviceKey === 'aeps');
  const hasAepsPermission = aepsService ? aepsService.isActive : false;

  const renderHierarchy = (hierarchy) => {
    if (!hierarchy) return null;

    // Build hierarchy array from bottom to top
    const buildHierarchyArray = (node) => {
      const nodes = [];
      let current = node;
      while (current) {
        nodes.unshift(current);
        current = current.parent;
      }
      return nodes;
    };

    const hierarchyArray = buildHierarchyArray(hierarchy);

    return (
      <div className="grid grid-cols-1 gap-4">
        {hierarchyArray.map((node, index) => (
          <div key={node.userId} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="p-3 bg-gray-50 rounded">
              <p className="text-sm text-gray-600">Level {index + 1} - {node.role.replace(/_/g, ' ')}</p>
              <p className="font-medium">{node.name}</p>
            </div>
            <div className="p-3 bg-gray-50 rounded">
              <p className="text-sm text-gray-600">Mobile Number</p>
              <p className="font-medium">{node.mobileNo}</p>
            </div>
            <div className="p-3 bg-gray-50 rounded">
              <p className="text-sm text-gray-600">User ID</p>
              <p className="font-medium">{node.userId}</p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Merchant Details</h1>

      {/* Search Section */}
      <div className="bg-white shadow-md rounded-lg p-6 mb-6 border border-gray-200">
        <h2 className="text-xl font-semibold mb-4 text-gray-700">Search by Mobile Number</h2>
        <div className="flex gap-4 items-start flex-col sm:flex-row">
          <div className="flex-1">
            <input
              type="text"
              value={mobileNumber}
              onChange={handleMobileNumberChange}
              placeholder="Enter Mobile Number (6-10 digits, starting with 6-9)"
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-colors ${
                !mobileValidationStatus.isValid && mobileNumber
                  ? 'border-red-300 bg-red-50'
                  : 'border-gray-300'
              }`}
              maxLength={10}
            />
            {!mobileValidationStatus.isValid && mobileNumber && (
              <p className="text-red-500 text-xs mt-1">{mobileValidationStatus.message}</p>
            )}
            {mobileNumber && mobileValidationStatus.isValid && (
              <p className="text-green-500 text-xs mt-1">✓ Valid mobile number</p>
            )}
          </div>
          <button
            onClick={handleSearch}
            disabled={loading || !mobileValidationStatus.isValid || !mobileNumber}
            className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
          >
            {loading ? (
              <span className="flex items-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Searching...
              </span>
            ) : "Search"}
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-2">
          • Mobile number must be 6-10 digits long<br/>
          • Must start with digits 6, 7, 8, or 9
        </p>
      </div>

      {/* Notification Component */}
      {notification && (
        <div className={`mb-6 p-4 rounded-lg border-l-4 ${notification.type === 'success'
            ? 'bg-green-50 border-green-400 text-green-800'
            : 'bg-red-50 border-red-400 text-red-800'
          } relative`}>
          <div className="flex">
            <div className="flex-shrink-0">
              {notification.type === 'success' ? (
                <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              )}
            </div>
            <div className="ml-3 flex-1">
              <p className="font-medium whitespace-pre-line">{notification.message}</p>
            </div>
            <div className="ml-auto pl-3">
              <button
                onClick={() => setNotification(null)}
                className="inline-flex text-gray-400 hover:text-gray-600"
              >
                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading State */}
      {loading && (
        <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
          <div className="animate-pulse space-y-4">
            <div className="h-6 bg-gray-300 rounded w-1/3" />
            <div className="h-4 bg-gray-200 rounded w-1/2" />
            <div className="h-4 bg-gray-200 rounded w-1/4" />
          </div>
        </div>
      )}

      {/* Merchant Data Display */}
      {userData && !loading && (
        <div className="space-y-6">
          {/* AEPS KYC Status with Toggle */}
          <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
            <h2 className="text-xl font-semibold mb-4 text-gray-700">AEPS KYC & Service Status</h2>
            
            {/* KYC Status */}
            <div className="mb-6">
              <h3 className="text-lg font-medium mb-3 text-gray-600">KYC Verification</h3>
              <div className="flex items-center gap-3">
                <div className={`flex items-center gap-2 px-4 py-2 rounded-full ${
                  userData.aepsKyc ? 'bg-green-100 text-green-800 border border-green-300' : 'bg-red-100 text-red-800 border border-red-300'
                }`}>
                  {userData.aepsKyc ? (
                    <>
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <span className="font-medium">KYC Verified</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                      <span className="font-medium">KYC Pending</span>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* AEPS Service Status with Toggle */}
            <div className="p-4 bg-gradient-to-r from-gray-50 to-blue-50 rounded-lg border border-gray-200">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-medium mb-2 text-gray-600">AEPS Service Status</h3>
                  <div className="flex items-center space-x-3">
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${userData.isAepsEnabled
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                      }`}>
                      {userData.isAepsEnabled ? '✅ Enabled' : '❌ Disabled'}
                    </span>
                    {/* Service Permission Indicator */}
                    {serviceLoading ? (
                      <div className="animate-pulse">
                        <div className="h-4 bg-gray-300 rounded w-20"></div>
                      </div>
                    ) : (
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                        hasAepsPermission
                          ? 'bg-blue-100 text-blue-800'
                          : 'bg-orange-100 text-orange-800'
                      }`}>
                        {hasAepsPermission ? '🔑 Can Manage' : '🔒 No Permission'}
                      </span>
                    )}
                  </div>
                  {!hasAepsPermission && !serviceLoading && (
                    <p className="text-xs text-orange-600 mt-1">
                      Contact administrator for AEPS management access
                    </p>
                  )}
                </div>
                <div className="flex flex-col items-end space-y-2">
                  <button
                    onClick={() => handleAepsToggle(userData.isAepsEnabled)}
                    disabled={loadingStates.AEPS_TOGGLE || serviceLoading || !hasAepsPermission}
                    className={`px-4 py-2 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ${
                      !hasAepsPermission
                        ? 'bg-gray-400 cursor-not-allowed'
                        : userData.isAepsEnabled
                          ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500'
                          : 'bg-green-600 hover:bg-green-700 focus:ring-green-500'
                      }`}
                  >
                    {loadingStates.AEPS_TOGGLE ? (
                      <span className="flex items-center">
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Processing...
                      </span>
                    ) : serviceLoading ? (
                      'Loading...'
                    ) : !hasAepsPermission ? (
                      '🔒 Access Denied'
                    ) : (
                      userData.isAepsEnabled ? '🔴 Disable AEPS' : '🟢 Enable AEPS'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Merchant Details from userHighLevelRolesResponse */}
          {userData.userHighLevelRolesResponse && (
            <>
              {/* Basic Merchant Information */}
              <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
                <h2 className="text-xl font-semibold mb-4 text-gray-700">Merchant Information</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div className="p-3 bg-blue-50 rounded">
                    <p className="text-sm text-gray-600">User ID</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.userId}</p>
                  </div>
                  <div className="p-3 bg-blue-50 rounded">
                    <p className="text-sm text-gray-600">Mobile Number</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.mobile_number}</p>
                  </div>
                  <div className="p-3 bg-blue-50 rounded">
                    <p className="text-sm text-gray-600">Role Type</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.role_type}</p>
                  </div>
                  <div className="p-3 bg-blue-50 rounded">
                    <p className="text-sm text-gray-600">Onboarding Status</p>
                    <p className="font-medium text-green-600">{userData.merchantOnboardingStatus}</p>
                  </div>
                  <div className="p-3 bg-blue-50 rounded">
                    <p className="text-sm text-gray-600">Created At</p>
                    <p className="font-medium">{userData.createdAt ? new Date(userData.createdAt).toLocaleString() : 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-blue-50 rounded">
                    <p className="text-sm text-gray-600">Updated At</p>
                    <p className="font-medium">{userData.updatedAt ? new Date(userData.updatedAt).toLocaleString() : 'N/A'}</p>
                  </div>
                </div>
              </div>

              {/* Personal Details */}
              <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
                <h2 className="text-xl font-semibold mb-4 text-gray-700">Personal Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div className="p-3 bg-green-50 rounded">
                    <p className="text-sm text-gray-600">Full Name</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.fullName || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-green-50 rounded">
                    <p className="text-sm text-gray-600">Father's Name</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.fatherName || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-green-50 rounded">
                    <p className="text-sm text-gray-600">Date of Birth</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.dob || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-green-50 rounded">
                    <p className="text-sm text-gray-600">Gender</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.gender || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-green-50 rounded">
                    <p className="text-sm text-gray-600">Aadhar Number</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.aadharNumber || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-green-50 rounded">
                    <p className="text-sm text-gray-600">Aadhar Address</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.aadharAddress || 'N/A'}</p>
                  </div>
                </div>
              </div>

              {/* Shop Details */}
              <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
                <h2 className="text-xl font-semibold mb-4 text-gray-700">Shop Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="p-3 bg-yellow-50 rounded">
                    <p className="text-sm text-gray-600">Shop Name</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopName || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-yellow-50 rounded">
                    <p className="text-sm text-gray-600">Shop Address</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopAddress || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-yellow-50 rounded">
                    <p className="text-sm text-gray-600">Shop State</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopState || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-yellow-50 rounded">
                    <p className="text-sm text-gray-600">Shop District</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopDistrict || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-yellow-50 rounded">
                    <p className="text-sm text-gray-600">Shop Pin Code</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopPinCode || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-yellow-50 rounded">
                    <p className="text-sm text-gray-600">Shop Landmark</p>
                    <p className="font-medium">{userData.userHighLevelRolesResponse.meta?.shopLandmark || 'N/A'}</p>
                  </div>
                </div>
              </div>

              {/* User Hierarchy */}
              {userData.userHighLevelRolesResponse.userHierarchyResponse && (
                <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
                  <h2 className="text-xl font-semibold mb-4 text-gray-700">User Hierarchy</h2>
                  <div className="space-y-6">
                    {renderHierarchy(userData.userHighLevelRolesResponse.userHierarchyResponse)}
                  </div>
                </div>
              )}
            </>
          )}

          {/* AEPS Transaction Details - Moved to Last */}
          {userData.aepsTxnDetails && userData.aepsTxnDetails.length > 0 && (
            <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-gray-700">AEPS Transaction Details</h2>
                <button
                  onClick={() => setShowTransactionDetails(!showTransactionDetails)}
                  className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors"
                >
                  <span>View</span>
                  <svg 
                    className={`w-4 h-4 transition-transform ${showTransactionDetails ? 'rotate-180' : ''}`} 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>

              {showTransactionDetails && (
                <div className="space-y-4">
                  {userData.aepsTxnDetails.map((txn, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">Transaction ID</p>
                          <p className="font-medium">{txn.txnId}</p>
                        </div>
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">Mobile Number</p>
                          <p className="font-medium">{txn.mobileNumber}</p>
                        </div>
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">Amount</p>
                          <p className="font-medium text-green-600">₹{txn.amount?.toLocaleString()}</p>
                        </div>
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">Status</p>
                          <p className={`font-medium ${txn.status === 'SUCCESS' ? 'text-green-600' : 'text-red-600'}`}>
                            {txn.status}
                          </p>
                        </div>
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">Aadhaar Number</p>
                          <p className="font-medium">{txn.aadhaarNumber}</p>
                        </div>
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">External Txn ID</p>
                          <p className="font-medium">{txn.externalTxnId || 'N/A'}</p>
                        </div>
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">Bank RRN</p>
                          <p className="font-medium">{txn.bankRRN || 'N/A'}</p>
                        </div>
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">Description</p>
                          <p className="font-medium">{txn.description || 'N/A'}</p>
                        </div>
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">Created At</p>
                          <p className="font-medium">{new Date(txn.created_at).toLocaleString()}</p>
                        </div>
                        <div className="p-3 bg-white rounded">
                          <p className="text-sm text-gray-600">Updated At</p>
                          <p className="font-medium">{new Date(txn.updated_at).toLocaleString()}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Helper Text for AEPS Operations */}
          <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
              <h3 className="font-semibold text-blue-800 mb-2">AEPS Service Management:</h3>
              <div className="text-sm text-blue-700 space-y-1">
                <p>• <strong>🟢 Enable AEPS:</strong> Activates AEPS service for the merchant {!hasAepsPermission && <span className="text-red-600">(Requires Permission)</span>}</p>
                <p>• <strong>🔴 Disable AEPS:</strong> Deactivates AEPS service for the merchant {!hasAepsPermission && <span className="text-red-600">(Requires Permission)</span>}</p>
                <p>• <strong>⚠️ Important:</strong> KYC verification is required for AEPS operations</p>
                <p>• <strong>🔑 Permission Required:</strong> Contact administrator if you don't have AEPS management access</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* No Data Message */}
      {!userData && !loading && (
        <div className="text-center py-8">
          <p className="text-gray-500">No merchant details found. Please search with a valid mobile number.</p>
        </div>
      )}
    </div>
  );
};

export default AepsMerchantdetails;